import Swiper, { Navigation, Pagination } from "swiper";
import "swiper/swiper-bundle.min.css";

const SwiperCarousel = {
  init() {
    const swiperInstances = {};

    // Initialize all Swipers
    document.querySelectorAll(".swiper-carousel").forEach((slider) => {
      const sliderId = slider.getAttribute("id");
      const sliderIdentifier = slider.dataset.id;
      const nextEl = document.querySelector(
        `.swiper-button-next-${sliderIdentifier}`
      );
      const prevEl = document.querySelector(
        `.swiper-button-prev-${sliderIdentifier}`
      );
      const paginationEl = document.querySelector(
        `.swiper-pagination-${sliderIdentifier}`
      );
      const counter = document.querySelector(
        `.swiper-counter[data-id="${sliderIdentifier}"]`
      );

      const swiper = new Swiper(`#${sliderId}`, {
        autoHeight: false,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        speed: 500,
        navigation: {
          nextEl,
          prevEl,
        },
        pagination: {
          el: paginationEl,
          type: "fraction",
        },
        breakpoints: {
          0: { autoHeight: true },
          768: { autoHeight: false },
        },
        modules: [Navigation, Pagination],
        on: {
          init: function () {
            updateCounter(this);
          },
          slideChange: function () {
            updateCounter(this);
          },
        },
      });

      function updateCounter(swiperInstance) {
        const totalSlides = swiperInstance.slides.length;
        const currentSlide = swiperInstance.realIndex + 1;
        if (counter && totalSlides > 0) {
          counter.textContent = `${currentSlide} / ${totalSlides}`;
        }
      }

      swiperInstances[sliderIdentifier] = swiper;
    });

    // Handle pin clicks
    document.querySelectorAll(".map-pin").forEach((pin) => {
      pin.addEventListener("click", () => {
        const pinId = pin.id.replace("pin-", ""); // e.g. "11"
        const targetSliderId = `single-slider-${pinId}`;

        // Toggle pin active state
        document
          .querySelectorAll(".map-pin")
          .forEach((p) => p.classList.remove("active"));
        pin.classList.add("active");

        // Toggle visible sliders
        document
          .querySelectorAll(".single-slider")
          .forEach((slider) => slider.classList.remove("active"));
        const targetSlider = document.getElementById(targetSliderId);
        if (targetSlider) {
          targetSlider.classList.add("active");

          const swiper = swiperInstances[pinId];
          if (swiper) {
            setTimeout(() => {
              swiper.update();
              swiper.slideTo(0);
              const counter = document.querySelector(
                `.swiper-counter[data-id="${pinId}"]`
              );
              if (counter) {
                const total = swiper.slides.length;
                counter.textContent = total ? `1 / ${total}` : `0 / 0`;
              }
            }, 50); // Give DOM time to update
          }
        }
      });
    });

    function removeActiveClassesIfMobile() {
      if (window.innerWidth <= 768) {
        // Mobile breakpoint
        document
          .querySelectorAll(".single-slider.active, .map-pin.active")
          .forEach(function (el) {
            el.classList.remove("active");
          });
      }
    }

    // Remove active classes on page load if on mobile
    document.addEventListener("DOMContentLoaded", removeActiveClassesIfMobile);

    // Also remove them when any .close-slider is clicked
    document.addEventListener("click", function (e) {
      if (e.target.closest(".close-slider")) {
        removeActiveClassesIfMobile();
      }
    });

    document.querySelectorAll(".map-pin").forEach((pin) => {
      pin.addEventListener("click", () => {
        if (window.innerWidth <= 768) {
          // Adjust if your mobile breakpoint differs
          const container = document.querySelector(".map-overflow");
          container.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
      });
    });

    document.querySelectorAll(".map-pin").forEach((pin) => {
      pin.addEventListener("click", () => {
        console.log("scrollingtop");
        if (window.innerWidth <= 768) {
          const target = document.querySelector("#interactiveMap");

          if (target) {
            const offsetTop =
              target.getBoundingClientRect().top + window.pageYOffset;
            console.log("scrollingtop");
            window.scrollTo({
              top: offsetTop,
              behavior: "smooth",
            });
          }
        }
      });
    });
  },
};

export default SwiperCarousel;
